import { useEffect, useMemo } from "react";
import { Map } from "components";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "store";
import { parseVehicleMaps } from "utils/parsers";
import { initializeVehicles } from "store/actions";
import { useInterval } from "utils/hooks";
import { POLLING_MSECS } from "utils/constants";
import {useCookies} from "react-cookie";
import {markerObject} from "../../../types";
import useDebounce from "utils/hooks";

const getFormatedDate = (unixTime:number) => {
  const inputDate = new Date(unixTime * 1000);

  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
  };

  return inputDate.toLocaleString('en-US', options);
}

export default function MapView() {
  const dispatch = useDispatch();
  const {
    vehicles,
    search,
    filters: { updated },
    page: { selectedPage },
  } = useSelector<AppState, AppState["vehicles"]>((state) => state.vehicles);
  const {
    map_marker,
    is_map_marker_change,
  } = useSelector<AppState, AppState["map_marker"]>((state) => state.map_marker);
  const [cookies] = useCookies()
  const parsedVehicles = useMemo(() => parseVehicleMaps(vehicles), [vehicles]);
  const markersPoint = useMemo(() => {
    return parsedVehicles.map((vehicle) => ({
      id: vehicle.id,
      lat: vehicle.point?.latitude || 0,
      lng: vehicle.point?.longitude || 0,
      licence_plate: vehicle?.licensePlate || "",
      updated_time: getFormatedDate(vehicle.locationUpdatedAt || 0),
      functional_status: vehicle.vehicleFunctionalStatus,
      checked_out_name: vehicle.checkedOutByName,
      model_type: vehicle.model_type || 1,
    }));
    //return [{id:"123", lat:31.501660, lng:74.361969}]
  }, [parsedVehicles]);
  useInterval(() => {
    dispatch(initializeVehicles(selectedPage,
        updated, true, false));
    console.log("check interva");
  }, POLLING_MSECS);
  const debounceSearchString = useDebounce(search, 1000);
  useEffect(() => {
    dispatch(initializeVehicles(selectedPage, updated, true));
  }, [dispatch, selectedPage, updated, debounceSearchString]);
  console.log("markersPoint : ", markersPoint)
  return <Map markersPoint={markersPoint} center={map_marker} />;
}
